function secondsToReadableTime(seconds: number): string {
  let secondsValue = seconds;
  const years = Math.floor(secondsValue / 31536000);
  const max = 2;
  let current = 0;
  let str = '';
  if (years && current < max) {
    str += years + 'y ';
    current++;
  }
  const days = Math.floor((secondsValue %= 31536000) / 86400);
  if (days && current < max) {
    str += days + 'd ';
    current++;
  }
  const hours = Math.floor((secondsValue %= 86400) / 3600);
  if (hours && current < max) {
    str += hours + 'h ';
    current++;
  }
  const minutes = Math.floor((secondsValue %= 3600) / 60);
  if (minutes && current < max) {
    str += minutes + 'm ';
    current++;
  }
  const calculatedSeconds = secondsValue % 60;
  if (calculatedSeconds && current < max) {
    str += calculatedSeconds + 's ';
    current++;
  }

  return str;
}

export default secondsToReadableTime;
